export enum EAnalytics {
  SUPPLIER_LANDING_V = 'Supplier_Landing_V',
  SUPPLIER_LANDING_ABOUT_WB_V = 'Supplier_Landing_AboutWb_V',
  SUPPLIER_LANDING_ABOUT_WB_INFO_BUTTON_T = 'Supplier_Landing_AboutWb_InfoButton_T',
  SUPPLIER_LANDING_STEPS_TO_START_V = 'Supplier_Landing_StepsToStart_V',
  SUPPLIER_LANDING_STEPS_TO_START_T = 'Supplier_Landing_StepsToStart_T',
  SUPPLIER_LANDING_STEPS_TO_START_LINK_T = 'Supplier_Landing_StepsToStart_Link_T',
  SUPPLIER_LANDING_FOOTER_V = 'Supplier_Landing_Footer_V',
  SUPPLIER_LANDING_FOOTER_T = 'Supplier_Landing_Footer_T',
  SUPPLIER_LANDING_FOOTER_CONTACTS_T = 'Supplier_Landing_Footer_Contacts_T',
  SUPPLIER_LANDING_AUTH_BUTTON_V = 'Supplier_Landing_AuthButton_V',
  SUPPLIER_LANDING_AUTH_BUTTON_T = 'Supplier_Landing_AuthButton_T',
  SUPPLIER_LANDING_HEADER_ELEMENT_V = 'Supplier_Landing_Header_Element_V',
  SUPPLIER_LANDING_HEADER_ELEMENT_T = 'Supplier_Landing_Header_Element_T',
  SUPPLIER_LANDING_MENU_V = 'Supplier_Landing_Menu_V',
  SUPPLIER_LANDING_MENU_HEADER_T = 'Supplier_Landing_Menu_Header_T',
  SUPPLIER_LANDING_MENU_HEADER_V = 'Supplier_Landing_Menu_Header_V',
  SUPPLIER_LANDING_MENU_SERVICES_T = 'Supplier_Landing_Menu_Services_T',
  SUPPLIER_LANDING_MENU_LANGUAGE_CHANGE_BUTTON_T = 'Supplier_Landing_Menu_Language_ChangeButton_T',
  SUPPLIER_LANDING_WB_PARTNERS_V = 'Supplier_Landing_WBPartners_V',
  SUPPLIER_LANDING_WB_PARTNERS_T = 'Supplier_Landing_WBPartners_T',
  SUPPLIER_LANDING_PROMO_V = 'Supplier_Landing_Promo_V',
  SUPPLIER_LANDING_PROMO_SUBBLOCK_V = 'Supplier_Landing_Promo_SubBlock_V',
  SUPPLIER_LANDING_PROMO_T = 'Supplier_Landing_Promo_T',
  SUPPLIER_LANDING_PROMO_POPUP_V = 'Supplier_Landing_Promo_Popup_V',
  SUPPLIER_LANDING_PROMO_POPUP_T = 'Supplier_Landing_Promo_Popup_T',
  SUPPLIER_LANDING_PRO_WB_FARVATER_BANNER_V = 'Supplier_Landing_ProwbFarvater_Banner_V',
  SUPPLIER_LANDING_PRO_WB_FARVATER_BANNER_T = 'Supplier_Landing_ProwbFarvater_Banner_T',
  SUPPLIER_LANDING_SUPPORT_V = 'Supplier_Landing_Support_V',
  SUPPLIER_LANDING_SUPPORT_T = 'Supplier_Landing_Support_T',
  SUPPLIER_LANDING_SUCCESS_STORY_V = 'Supplier_Landing_SuccessStory_V',
  SUPPLIER_LANDING_SUCCESS_STORY_SUBBLOCK_V = 'Supplier_Landing_SuccessStory_SubBlock_V',
  SUPPLIER_LANDING_SUCCESS_STORY_T = 'Supplier_Landing_SuccessStory_T',
  SUPPLER_LANDING_SALES_SCHEME_POPUP_V = 'Supplier_Landing_SalesScheme_Popup_V',
  SUPPLER_LANDING_SALES_SCHEME_POPUP_LINK_T = 'Supplier_Landing_SalesScheme_Popup_Link_T',
}

export enum ELandingABTest {
  TEST = 'test_1',
  CONTROL = 'control_1',
}

export enum ENumberOfCalls {
  ONCE = 'once',
  REGULARLY = 'regularly',
}

const TWO_SECONDS_MS = 2000;
const FIVE_SECONDS_MS = 5000;

export const WATCH_OF_INTERSECTING_DELAY = [TWO_SECONDS_MS, FIVE_SECONDS_MS];
export const WATCH_OF_INTERSECTING_DELAY_TWO_SECONDS = [TWO_SECONDS_MS];

export const APP_VERSION = process.env.NEXT_PUBLIC_SENTRY_RELEASE || '';

export enum ELoginButtonPagePosition {
  LOGIN = 'login',
  UP_NEAR_LOGIN = 'up_near_login',
  UP = 'up',
  BOTTOM = 'bottom',
}
